module.exports = __webpack_public_path__ + "static/img/3.63986c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/3.png
// module id = hVQx
// module chunks = 0